"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DEFAULT_TIMEOUT = exports.ButtonTypes = void 0;
var _react = _interopRequireWildcard(require("react"));
var _starWhite = _interopRequireDefault(require("./starWhite.svg"));
require("./styles.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * This is the Button component that will be used in school-ui
 * The following are the props that can be passed to the component
 *
 * @property {String} label The label of the button (Ex: Okay, Save, etc...).
 * @property {ButtonTypes} type The type of button to be rendered.
 * @property {Function?} onClick Pass any function to be executed.
 * @property {Boolean} loading This property will set the state of button, Use this to pass state of api loading/resolved. (loading -> disabled).
 * @property {Number} customTimeout This property can be used to supply a custom timeout during which the button will be disabled.
 * @property {Boolean} disabled This property will set the state of button to be disabled.
 * @property {String} className This property will be used to pass extra classNames for the button for additional customization.
 * @property {Object} style If any, this property can be used to pass additional styles to the button.
 * @property {JSX} children If any, this property will be used to pass the children to the component.
 * @property {Boolean} stopPropagation, this property will decide whether to bubble up the event or not.
 *
 * @Note
 * 1) Each instance of the Button component must contains these props:
 *   a) Either `label` or `children` prop to render the text inside button.
 *   b) `type`: a type from ButtonTypes.
 *   c) Either `onClick` or `disabled` prop to either have a functional or disabled button.
 *
 * 2) By default a timeout period of 2 seconds is there, but user can change this via `customTimeout` prop.
 **/

//Default timeout period in milliseconds
var DEFAULT_TIMEOUT = 2000;

// ButtonTypes
exports.DEFAULT_TIMEOUT = DEFAULT_TIMEOUT;
var ButtonTypes = {
  primary: "primary-cta-button",
  secondary: "secondary-cta-button",
  star: "primary-cta-button star-btn",
  custom: {
    "default": "default-cta-button",
    inline: "inline-cta-button",
    sync: "sync-cta-button"
  }
};

// Component
exports.ButtonTypes = ButtonTypes;
var Button = function Button(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? "" : _ref$label,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? "" : _ref$type,
    _ref$onClick = _ref.onClick,
    _onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$customTimeout = _ref.customTimeout,
    customTimeout = _ref$customTimeout === void 0 ? null : _ref$customTimeout,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$stopPropagation = _ref.stopPropagation,
    stopPropagation = _ref$stopPropagation === void 0 ? true : _ref$stopPropagation,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDisabled = _useState2[0],
    setIsDisabled = _useState2[1];
  var callAndDisable = function callAndDisable(e) {
    var callbackFunction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    var timeout = arguments.length > 2 ? arguments[2] : undefined;
    stopPropagation ? e.stopPropagation() : null;
    e.preventDefault();
    if (!isDisabled) {
      setIsDisabled(true);
      callbackFunction();
      var taskToDefer = function taskToDefer() {
        setIsDisabled(false);
      };
      setTimeout(function () {
        return taskToDefer();
      }, timeout);
    }
  };
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "".concat(type || "", " ").concat(className || "", " ").concat(className === "" && type === "" ? ButtonTypes.primary : "", " ").concat(isDisabled || loading || disabled ? 'disabled' : ''),
    style: style || {},
    onClick: function onClick(e) {
      return loading ? null : callAndDisable(e, _onClick, customTimeout ? customTimeout : DEFAULT_TIMEOUT);
    },
    "data-sentry-component": "Button",
    "data-sentry-source-file": "index.tsx"
  }, label || "", children, type === ButtonTypes.star ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "button-star-container"
  }, /*#__PURE__*/_react["default"].createElement(_starWhite["default"], null)) : null);
};
var _default = Button;
exports["default"] = _default;